import { axiosV2 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type CheckPartnerEncumbrancesByDateProps = {
  societyId: string;
  partnerId: string;
  date: Date;
};

export const checkPartnerEncumbrancesByDate =
  ({ societyId, partnerId, date }: CheckPartnerEncumbrancesByDateProps) =>
  async (dispatch: Dispatch) => {
    const query = { params: { societyId, partnerId, date } };

    try {
      const { data } = await axiosV2.get(
        '/partners/hasEncumbrancesAtDate',
        query
      );

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
